import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
	AlarisDialogComponent,
	AlarisIconDirective,
	AlarisTableComponent,
	ChannelUtilsService,
	filterWildcardData,
	LocalTableUtils,
	TableEntityField,
	TableFiltersIndicator,
	TableSortIndicator,
} from '@campaign-portal/components-library';
import { InputType } from '@campaign-portal/namespace/common/entityField';
import { FilterType, SortDirection } from '@campaign-portal/namespace/common/rpc.params';
import { Package, Plan } from '@campaign-portal/namespace/entities/subscriptions/specs';
import { TranslateModule } from '@ngx-translate/core';

export interface AllCountriesDialogData {
	item: Package | Plan;
}

export interface CountryElement {
	country: string;
}

@Component({
	selector: 'app-all-countries-dialog',
	templateUrl: './all-countries-dialog.component.html',
	styleUrls: ['../dialogs.component.scss', './all-countries-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AlarisDialogComponent, TranslateModule, AlarisIconDirective, AlarisTableComponent],
	standalone: true,
})
export class AllCountriesDialogComponent {
	readonly headers: TableEntityField[] = [
		new TableEntityField({
			id: 0,
			name: 'columns.country',
			variable: 'country',
			required: true,
			type: InputType.TEXT,
			filterType: FilterType.LIKE,
			readonly: true,
		}),
	];
	readonly filters: TableFiltersIndicator = new Map().set('country', { enabled: true, value: undefined });
	readonly sorting: TableSortIndicator = new Map().set('country', { enabled: true, value: SortDirection.EMPTY });

	tRows: CountryElement[];
	readonly item: Package | Plan;
	private readonly tRowsDefault: CountryElement[];

	constructor(
		@Inject(DIALOG_DATA) public readonly data: AllCountriesDialogData,
		private readonly dialogRef: DialogRef,
		public readonly cu: ChannelUtilsService
	) {
		this.item = data.item;
		this.tRowsDefault = this.tRows = this.item.countries ? this.item.countries.map((country) => ({ country })) : [];
	}

	applyFilter($event: TableFiltersIndicator): void {
		this.tRows = [...this.tRowsDefault];
		for (const [, filter] of $event.entries()) {
			if (filter?.value && filter.enabled) {
				const subStr = (filter.value as string).trim().toLowerCase();
				this.tRows = filterWildcardData(subStr, this.tRows, 'country');
			}
		}
	}

	applySorting($event: TableSortIndicator): void {
		for (const [, sort] of $event.entries()) {
			if (sort?.value && sort.enabled) {
				this.tRows = this.tRows.sort((a, b) => {
					const first = a.country;
					const second = b.country;
					return LocalTableUtils.sortComparisonFn(sort.value ?? SortDirection.EMPTY, first, second);
				});
			}
		}
	}

	close(): void {
		this.dialogRef.close();
	}
}
